<template>
  <div class="search">
    <input
      type="text"
      placeholder=" Choose in which platform you want to see"
      class="search--input"
      v-model="search"
      @keyup.prevent="searchItem()"
    />
    <font-awesome-icon class="search--icon" icon="search" />
    <font-awesome-icon
      v-show="search"
      class="search--icon-right"
      icon="times"
      @click="resetCriteria()"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    search: ""
  }),
  watch: {},
  created() {
    this.resetCriteria();
  },
  methods: {
    resetCriteria() {
      this.search = "";
      this.$store.commit("editPlatformsFull", "");
    },
    searchItem() {
      if (this.search.length > 2)
        this.$store.commit("editPlatformsFull", this.search);
      else this.$store.commit("editPlatformsFull", "");
    }
  }
};
</script>

<style scoped>
.search {
  padding: 0 2%;
  position: relative;
  width: 96%;
}
.search--input {
  width: 100%;
  margin: 0;
  background-color: #284367;
  padding: 7px 5% 7px 32px;
  border-radius: 15px;
  border: 0px;
  box-sizing: border-box;
}
.search--input::placeholder {
  padding-left: 0%;
}

.search--icon {
  color: rgba(255, 255, 255, 0.86);
  position: absolute;
  left: 28px;
  top: 7px;
  z-index: 1000;
}
.search--icon-right {
  color: rgba(255, 255, 255, 0.86);
  position: absolute;
  right: 28px;
  top: 7px;
  z-index: 1000;
  padding-left: 29px;
  cursor: pointer;
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .search--icon {
    left: 28px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .search--icon {
    left: 22px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .search--icon {
    left: 18px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .search--icon {
    left: 18px;
  }
}

@media (max-width: 600px) {
  .search--icon {
    left: 12px;
  }
}
</style>
<style scoped>
input {
  color: rgba(255, 255, 255, 0.86);
}

input::placeholder {
  color: rgba(255, 255, 255, 0.56);
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
